// Export all API services
export { authApi } from './auth';
export { usersApi } from './users';
export { projectsApi } from './projects';
export { tasksApi } from './tasks';
export { notificationsApi } from './notifications';
export { timelineApi } from './timeline';
export { messagesApi } from './messages';

// Unified db object for backward compatibility
import { authApi } from './auth';
import { usersApi } from './users';
import { projectsApi } from './projects';
import { tasksApi } from './tasks';
import { notificationsApi } from './notifications';
import { timelineApi } from './timeline';
import { messagesApi } from './messages';

/**
 * Unified database interface for backward compatibility
 * This allows gradual migration from the old db.* pattern
 */
export const db = {
  // Auth
  inviteUser: authApi.inviteUser,
  signIn: authApi.signIn,
  signOut: authApi.signOut,
  updatePassword: authApi.updatePassword,

  // Users
  getUsers: usersApi.getAll,
  getUser: usersApi.getById,
  createUser: usersApi.upsert,
  updateUser: usersApi.update,
  deleteUser: usersApi.delete,

  // Projects
  getProjects: projectsApi.getAll,
  createProject: projectsApi.create,
  updateProject: projectsApi.update,
  deleteProject: projectsApi.delete,

  // Tasks
  getTasks: tasksApi.getAll,
  createTask: tasksApi.create,
  updateTask: tasksApi.update,
  deleteTask: tasksApi.delete,

  // Notifications
  getNotifications: notificationsApi.getByUser,
  addNotification: notificationsApi.create,
  updateNotification: (id: string, updates: { isRead?: boolean }) => 
    updates.isRead !== undefined ? notificationsApi.markAsRead(id) : Promise.resolve(),
  deleteNotification: notificationsApi.delete,
  deleteReadNotifications: notificationsApi.deleteRead,

  // Timeline
  getTimeline: timelineApi.getAll,
  addTimelineEvent: timelineApi.create,

  // Messages
  getMessages: messagesApi.getByProject,
  addMessage: messagesApi.create,
};

export default db;
